import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Grid, IconButton, Pagination, PaginationItem, Typography } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { AlertDiamondIcon, ArrowLeft01Icon, ArrowRight01Icon, Camera01Icon, Cancel01Icon, Car05Icon, Chair01Icon, 
    Dish02Icon, Dumbbell01Icon, FlashIcon, GeometricShapes01Icon, Motorbike02Icon, ShoppingCart02Icon, Store01Icon, 
    TShirtIcon, TvSmartIcon } from "@hugeicons/core-free-icons";
import axios from "axios";

// icons list
const iconList = [
  { name: "GeometricShapes01Icon", icon: GeometricShapes01Icon},
  { name: "Motorbike02Icon", icon: Motorbike02Icon},
  { name: "FlashIcon", icon: FlashIcon},
  { name: "ShoppingCart02Icon", icon: ShoppingCart02Icon},
  { name: "Dish02Icon", icon: Dish02Icon},
  { name: "TvSmartIcon", icon: TvSmartIcon},
  { name: "HangerIcon", icon: TShirtIcon},
  { name: "Car05Icon", icon: Car05Icon},
  { name: "Dumbbell01Icon", icon: Dumbbell01Icon},
  { name: "Chair01Icon", icon: Chair01Icon},
  { name: "Store01Icon", icon: Store01Icon},
  { name: "Camera01Icon", icon: Camera01Icon},
];

// icon render
const getCategoryIcon = (imageUrl, iconName, color) => {
  if (imageUrl) {
    const fullImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `http://127.0.0.1:8000${imageUrl}`;
    return (
      <Box
        component="img"
        src={fullImageUrl}
        alt="Category Icon"
        sx={{ width: 24, height: 24, borderRadius: "4px" }}
      />
    );
  }
  if (iconName) {
    const foundIcon = iconList.find((icon) => icon.name === iconName);
    if (foundIcon) {
      return (
        <HugeiconsIcon
          icon={foundIcon.icon}
          size={24}
          color={color}
          style={{ fill: "currentColor", strokeWidth: 0 }}
        />
      );
    }
  }
  return null;
};

const NewBill = ({ open, onClose, onSuccess }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [trackers, setTrackers] = useState([]);
  const [selectedTracker, setSelectedTracker] = useState(null);

  const [page, setPage] = useState(1);
  const categoriesPerPage = 8;

  const fetchCategories = () => {
    axios
      .get("http://127.0.0.1:8000/categories/list")
      .then((res) => setCategories(res.data))
      .catch((err) => console.error("API Error:", err));
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const indexOfLast = page * categoriesPerPage;
  const indexOfFirst = indexOfLast - categoriesPerPage;
  const currentCategories = categories.slice(indexOfFirst, indexOfLast);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSelectedTracker(null); 

    axios
      .get(`http://127.0.0.1:8000/tracker/${category.id}/tracker-list`)
      .then((res) => setTrackers(res.data))
      .catch((err) => {
        console.error("Tracker API Error:", err);
        setTrackers([]);
      });
  };

  const handleTrackerClick = (tracker) => {
    setSelectedTracker(tracker);
  };

  const handleContinue = () => {
    if (selectedTracker) {
      onSuccess(selectedTracker);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Box>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          bgcolor="#EEF4FF"
          px={3}
          py={1.5}
        >
          <Typography fontSize={16} fontWeight={600}>
            Select Category & Diary
          </Typography>
          <IconButton size="small" onClick={onClose}>
            <HugeiconsIcon icon={Cancel01Icon} size={20} color="#344054" />
          </IconButton>
        </Box>

        <Box p={2}>
          {/* Categories */}
          <Box mt={2} p={2} sx={{ background: "#f7f7f7", borderRadius: "12px" }}>
            <Grid container spacing={2}>
              {currentCategories.map((category, index) => (
                <Grid item xs={6} sm={4} md={3} lg={2.4} key={index}>
                  <Box
                    onClick={() => handleCategoryClick(category)}
                    sx={{
                      border:
                        selectedCategory?.id === category.id
                          ? "2px solid #0b57d0"
                          : "1px solid #ddd",
                      borderRadius: "12px",
                      p: 1.5,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      background:
                        selectedCategory?.id === category.id ? "#e3f0ff" : "#fff",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {getCategoryIcon(
                        category.category_image,
                        category.category_icon,
                        category.color
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: "#000",
                        textTransform: "capitalize",
                      }}
                    >
                      {category.category_name}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {categories.length === 0 && (
              <Typography
                sx={{
                  textAlign: "center",
                  mt: 4,
                  color: "#999",
                  fontSize: 14,
                }}
              >
                No categories found.
              </Typography>
            )}
          </Box>

          {/* Diaries (after category select) */}
          {selectedCategory && (
            <Box
              mt={3}
              p={2}
              sx={{ background: "#f0f8ff", borderRadius: "12px" }}
            >
              <Typography fontSize={15} fontWeight={600} mb={1}>
                Select Diary for "{selectedCategory.category_name}"
              </Typography>

              <Grid container spacing={2}>
                {trackers.map((tracker) => (
                  <Grid item xs={6} sm={4} md={3} key={tracker.id}>
                    <Box
                      onClick={() => handleTrackerClick(tracker)}
                      sx={{
                        border:
                          selectedTracker?.id === tracker.id
                            ? "2px solid #0b57d0"
                            : "1px solid #ddd",
                        borderRadius: "12px",
                        p: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background:
                          selectedTracker?.id === tracker.id ? "#e3f0ff" : "#fff",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: "#000",
                          textTransform: "capitalize",
                        }}
                      >
                        {tracker.name}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>

              {trackers.length === 0 && (
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 2,
                    color: "#999",
                    fontSize: 14,
                  }}
                >
                  No diaries found for this category.
                </Typography>
              )}
            </Box>
          )}

          {/* Pagination */}
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <Pagination
              count={Math.ceil(categories.length / categoriesPerPage)}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              siblingCount={1}
              boundaryCount={1}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  components={{
                    previous: () => (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "8px",
                        }}
                      >
                        <HugeiconsIcon icon={ArrowLeft01Icon} size={18} />
                        <Typography sx={{ fontSize: 14, marginLeft: "4px" }}>
                          Previous
                        </Typography>
                      </Box>
                    ),
                    next: () => (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          paddingRight: "8px",
                        }}
                      >
                        <Typography sx={{ fontSize: 14, marginRight: "4px" }}>
                          Next
                        </Typography>
                        <HugeiconsIcon icon={ArrowRight01Icon} size={18} />
                      </Box>
                    ),
                  }}
                />
              )}
            />
          </Box>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
          >
            <HugeiconsIcon icon={AlertDiamondIcon} size={16} />
            <Typography
              variant="body2"
              sx={{ color: "#777", textAlign: "center", fontSize: "13px" }}
            >
              Select a diary related to the category for more precise data.
            </Typography>
          </Box>

          {/* Continue Button */}
          <Box display="flex" justifyContent="center" mt={3} mb={3}>
            <Button
              variant="contained"
              disabled={!selectedTracker}
              onClick={handleContinue}
              sx={{
                textTransform: "none",
                borderRadius: "50px",
                backgroundColor: "#0b57d0",
              }}
            >
              Continue to Add Bill
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default NewBill;